import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-preincubator-reject',
  templateUrl: './preincubator-reject.component.html',
  styleUrls: ['./preincubator-reject.component.css'],
})
export class PreincubatorRejectComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  private getApi = environment.url + 'preincubation/dashboard?id=';
  private preincubaterapproval =
    environment.url + environment.preincubaterapproval;
  /**
   * Construct a new PreincubatorRejectComponent.
   * @param data The data that has been passed from the parent component.
   * @param fb The form builder service.
   * @param makeapi The API service.
   * @param getdata The value service.
   * @param notify The notification service.
   * @param dialogRef The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<PreincubatorRejectComponent>
  ) {
    /**
     * The form group for the reason form.
     */
    this.reasonForm = this.fb.group({
      /**
       * The id of the preincubator.
       */
      id: [''],
      /**
       * The status of the preincubator.
       */
      status: [''],
      /**
       * The reason for rejecting the preincubator.
       */
      reason: ['', [Validators.required]],
    });
    /**
     * The data that has been passed from the parent component.
     */
    this.datas = data;
  }
  ngOnInit(): void {}
  get add() {
    return this.reasonForm.controls;
  }
  preIncubatorId = sessionStorage.getItem('userId');
  /**
   * Saves the rejection reason to the API.
   * Validates the form, constructs the request payload, and sends it using the API service.
   * Provides user feedback based on the server response.
   */
  saveReason() {
    // Check if the form is invalid
    if (this.reasonForm.invalid) {
      // Mark all form fields as touched to show validation errors
      this.reasonForm.markAllAsTouched();
      // Notify the user about the invalid form
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Prepare the request payload
      let req = {
        userId: this.preIncubatorId, // User ID performing the action
        status: this.datas._id, // Current status of the pre-incubator
        remarks: this.reasonForm.value.reason, // Rejection reason
      };
      // Show a loading indicator
      this.getdata.amizhthLoader('show');
      // Send the request to the API
      return this.makeapi
        .method(this.preincubaterapproval, req, 'post')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');
          // Check if the response indicates success
          if (data.responseStatus !== 'Failed') {
            // Reset the form and close the dialog
            this.cancelReason();
            // Notify the user about the success
            this.notify.notifysuccess(data.responseMessage);
          } else {
            // Notify the user about the error
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Cancels the current operation.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    // Reset the form fields
    this.reasonForm.reset();
    // Close the dialog
    this.dialogRef.close();
  }
  dashboardData: any = {};
  /**
   * Fetches the dashboard data from the API and updates the component's data.
   * Shows a loading indicator during the request, and hides it when the request is complete.
   */
  getValue() {
    // Reset the component's data
    this.dashboardData = {};
    // Show a loading indicator
    this.getdata.amizhthLoader('show');
    // Make the API request
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');
        // Update the component's data
        this.dashboardData = data;
      });
  }
}
